import api from '../../../api/clinique/_parametre'

const state = () => ({
    countdown_info: {},
    config_info_clinique: {},
})

// getters
const getters = {
    countdown_info: (state) => {
        return state.countdown_info;
    },

    config_info_clinique: (state) => {
        return state.config_info_clinique
    },
}

// mutations
const mutations = {
    SET_COUNTDOWN_INFO(state, countdown) {
        state.countdown_info = countdown
    },

    SET_CONFIG_INFO_CLINIQUE(state, info) {
        state.config_info_clinique = info
    },
}

// actions
const actions = {
    getCountDown({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCountDown().then((response) => {
                commit("SET_COUNTDOWN_INFO", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getConfigInfoClinique({ commit }, data_type){
        return new Promise((resolve,reject) => {
            api.getConfigInfoClinique(data_type).then(
                response => {
                    commit('SET_CONFIG_INFO_CLINIQUE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}